import { useI18n } from 'vue-i18n'
import { useToast } from './useToast'

export function useShare() {
  const { showToast } = useToast()
  const { t } = useI18n()

  async function initShare(shareData: { url: string; title: string; text: string }) {
    if (navigator.share) {
      try {
        await navigator.share(shareData)
        showToast(t('photo.shared_successfully'))
      } catch (err) {
        console.error(err)
        showToast(t('photo.share_failed'))
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareData.url)
        showToast(t('photo.url_copied'))
      } catch (err) {
        console.error(err)
        showToast(t('photo.copy_failed'))
      }
    }
  }
  return {
    initShare
  }
}
